const initialState = {
  auth: {},
  isLoggedIn: false,
  userDetails: {},
  vendorDetails: {},
  vehicleList: [],
  materialLList: [],
  logoutUserId: null,
};

export default initialState;
